import script from "./PublisherSnapshotPanels.vue?vue&type=script&setup=true&lang=js"
export * from "./PublisherSnapshotPanels.vue?vue&type=script&setup=true&lang=js"

import "./PublisherSnapshotPanels.vue?vue&type=style&index=0&id=642b8bfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642b8bfa"]])

export default __exports__